/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyDayInfo,
    JsonEventPartyDayInfoFromJSON,
    JsonEventPartyDayInfoFromJSONTyped,
    JsonEventPartyDayInfoToJSON,
} from './JsonEventPartyDayInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventPartyDayInfo
 */
export interface ApiResultOfListOfJsonEventPartyDayInfo {
    /**
     * 
     * @type {Array<JsonEventPartyDayInfo>}
     * @memberof ApiResultOfListOfJsonEventPartyDayInfo
     */
    data?: Array<JsonEventPartyDayInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyDayInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventPartyDayInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyDayInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyDayInfo
     */
    result?: ApiResultOfListOfJsonEventPartyDayInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventPartyDayInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventPartyDayInfoFromJSON(json: any): ApiResultOfListOfJsonEventPartyDayInfo {
    return ApiResultOfListOfJsonEventPartyDayInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventPartyDayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventPartyDayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventPartyDayInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventPartyDayInfoToJSON(value?: ApiResultOfListOfJsonEventPartyDayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventPartyDayInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

